import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../media/logoImg.png";
import {
  faBars,
  faPhone,
  faArrowUpRightFromSquare,
  faStar,
  faX,
  faMinus,
  faAdd
} from "@fortawesome/free-solid-svg-icons";
import "../style/style.css";
import AOS from "aos";
import 'aos/dist/aos.css'
import "../style/resp.css";
import { useEffect, useState,useRef } from "react";
import allLogos from "../media/logos (1).png"
import azlogo from "../media/a-z-landscaping.svg";
import chosenmockup from "../media/chosen-on-base-mockup.png";
import runninggeorge from "../media/runninggorge.png";
import whitemountainsimg from "../media/wmc.png";
import upwork from "../media/upwork.png"
import a2z from "../media/a-to-z-landscaping.png";
import chosenonbase from "../media/chosen-on-base-logo.svg";
import running from "../media/running.png";
import phone1 from "../media/phone1.png";
import phone2 from "../media/phone2.png";
import laptop from "../media/laptop.png";
import gym from "../media/gym-near-me.png";
import jenn from "../media/jenns-beauty-salon.png";
import uniquedesign from "../media/uniquedesigns.png"
import azee from "../media/andrew-wandola (1).png";
import googleImg from "../media/googgle.png";
import star from "../media/star.png";
import axios from "axios";
import sneaky from "../media/read-sneakers.png";
import Swal from "sweetalert2";
import tarmac from "../media/tarmac-construction-logo.svg";
import whitemountains from "../media/white-mountain-construction-port-orchard.svg";

function Home() {
      const [currentIndex, setCurrentIndex] = useState(0);
        const firstnameUser =useRef(null)
        const floatBtnRef = useRef(null)
  const emUser =useRef(null)
  const knowUser = useRef(null)
  const budgetUser =useRef(null)
  const descUser =useRef(null)
  const fonUser =useRef(null)
  const navSlide = useRef(null)
  const floatContact = useRef(null)

  const hideFloatContact=()=>{
    floatContact.current.style.zIndex="-1"
    floatBtnRef.current.style.zIndex="9"
    if(window.innerWidth <= 992){
          floatBtnRef.current.style.display="flex"

    }else{
        floatBtnRef.current.style.display="none"

    }
  }
  const showFloatContact=()=>{
    cnclNavSlider()
    floatContact.current.style.zIndex="5"
    floatBtnRef.current.style.display="none"

  }


  const showNavSlider = ()=>{
    navSlide.current.style.right = "0%"
  }

  const cnclNavSlider =()=>{
        navSlide.current.style.right = "-105%"

  }
  const [activeIndex, setActiveIndex] = useState(null);
      const [errors, setErrors] = useState({
    fname:"",
    lname:"",
    email:"",
    phone:"",
    budget:"",
    know:"",
    description:"",
  })

   useEffect(()=>{
     AOS.init({duration: 1000})
  },[])

  const validateForm = ()=>{
    let valid = true;
    const newErrors = {fname:"",lname:"",email:"",phone:"",budget:"",know:"",description:""};


     if(!firstnameUser.current.value.trim()){
    newErrors.fname = "Your name is required";
    valid = false

  }
    
     if(!budgetUser.current.value.trim()){
    newErrors.budget = "Your budget is required";
    valid = false

  }
     if(!knowUser.current.value.trim()){
    newErrors.know = "This field is required";
    valid = false

  }

  
  const emailValue = emUser.current.value.trim();
  if(!emailValue){
    newErrors.email="Email is required"
    valid=false;

  }else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)){
    newErrors.email = "Enter a valid email";
    valid = false;
  }


  const phoneValue = fonUser.current.value.trim();
  if(!phoneValue){
    newErrors.phone="Phone number is required";
    valid=false
  }else if(!/^\d{7,15}$/.test(phoneValue)) { 
    newErrors.phone = "Enter a valid phone number";
    valid = false;
  

  }


  if (!descUser.current.value.trim()) {
    newErrors.description = "Please describe your project";
    valid = false;
  }


  setErrors(newErrors);
  return valid

}
const getQuote = () => {
  const name = firstnameUser.current.value;
  const em = emUser.current.value;
  const fon = fonUser.current.value;   
  const desc = descUser.current.value;
  const budget = budgetUser.current.value;   
  const know = knowUser.current.value;   

  
  if(!validateForm()){
     return;

    }
  Swal.fire("Sending message...")

  const url = "https://porr-orchard-oct-back.vercel.app/sendEmail";

  const body = `     
Greetings,

${desc}

Budget: ${budget}

I heard about you through ${know}.

Regards,
${name},
${fon},
${em}
  `;

  const data = {
    emUser: em,
    nameUser:name,
    body: body,
    subject: "Someone messaged you from your website"
  };

  axios.post(url, data)
    .then(response => {
      console.log("✅ Success:", response);
      Swal.fire(response.data.message || "Your inquiry has been sent successfully!");
    })
    .catch(error => {
      console.error("❌ Error:", error.response?.data || error.message);
      Swal.fire(error.response?.data?.message || "Failed to send your inquiry. Please try again later.");
    });
};

const toContact =()=>{
  cnclNavSlider()
    const contactPage = document.getElementById("contact")
    if(contactPage){
        contactPage.scrollIntoView({behavior:"smooth"})
    }
}
const toTestimonial =()=>{
    cnclNavSlider()

    const testPage = document.getElementById("testimonial")
    if(testPage){
        testPage.scrollIntoView({behavior:"smooth"})
    }
}
const toPortfolio =()=>{
  cnclNavSlider()
    const contactPage = document.getElementById("webdesign")
    if(contactPage){
        contactPage.scrollIntoView({behavior:"smooth"})
    }
}
const toFAQ =()=>{
  cnclNavSlider()
    const faqs = document.getElementById("faqs")
    if(faqs

    ){
        faqs.scrollIntoView({behavior:"smooth"})
    }
}
    const faqs = [
        {
            question:"How long does the design process take?",
            answer:"Yes, I offer ongoing support to keep your site running smoothly. I can handle updates, maintenance, and any troubleshooting you need. "
        },
        {
            question:"Do you offer ongoing support after the website is launched?",
            answer:"Yes, we offer ongoing support to keep your site running smoothly. We can handle updates, maintenance, and any troubleshooting you need."
        },
        {
            question:"What is included in your SEO services?",
            answer:"Typically, my SEO services in Port Orchard and throughout Kitsap County covers keyword research, on-page optimization, and local SEO strategies, and other technical stuff. I also track your performance and share monthly reports to ensure ongoing improvement."
        },
        {
            question:"Can you redesign my current website",
            answer:"Yes, that’s part of what I do for small businesses here in Port Orchard and throughout Kitsap County. Besides redesign, I can also improve its functionality and optimize it for better performance."
        },
        {
            question:"How do i get started?",
            answer:"It's easy: simply reach out to us for a free consultation. We’ll discuss your goals and create a plan that'll bring your vision to life."
        },
        {
            question:"I'm not a tech-savvy, will i be able to manage my own website?",
            answer:"Absolutely. We build websites that are easy to use, even if you have no technical experience. You can update your content, change images, and make basic edits on your own."
        },

    ]

    const testimonials = [
        {
            name:"Tarmac Construction",
            cont:"Andrew is awesome! From start to finish, he exceeded my expectations in designing and building my website. He made the entire process is extremely easy and seamless and was able to bring our vision into reality."
        },
        {
            name:"George Keller",
            cont:" Andrew is amazing, he listened to me .Then took my ideas and thoughts and turned then into a work of art. He is super creative, patient, kind and available through the whole process. I fell blessed to have found him."
        },
        {
            name:"Tarmac Construction",
            cont:"Andrew is awesome! From start to finish, he exceeded my expectations in designing and building my website. He made the entire process is extremely easy and seamless and was able to bring our vision into reality."
        },
        {
            name:"George Keller",
            cont:" Andrew is amazing, he listened to me .Then took my ideas and thoughts and turned then into a work of art. He is super creative, patient, kind and available through the whole process. I fell blessed to have found him."
        },
        {
            name:"Tarmac Construction",
            cont:"Andrew is awesome! From start to finish, he exceeded my expectations in designing and building my website. He made the entire process is extremely easy and seamless and was able to bring our vision into reality."
        },
        {
            name:"George Keller",
            cont:" Andrew is amazing, he listened to me .Then took my ideas and thoughts and turned then into a work of art. He is super creative, patient, kind and available through the whole process. I fell blessed to have found him."
        },
        {
            name:"Tarmac Construction",
            cont:"Andrew is awesome! From start to finish, he exceeded my expectations in designing and building my website. He made the entire process is extremely easy and seamless and was able to bring our vision into reality."
        },
        {
            name:"George Keller",
            cont:" Andrew is amazing, he listened to me .Then took my ideas and thoughts and turned then into a work of art. He is super creative, patient, kind and available through the whole process. I fell blessed to have found him."
        },
        {
            name:"Tarmac Construction",
            cont:"Andrew is awesome! From start to finish, he exceeded my expectations in designing and building my website. He made the entire process is extremely easy and seamless and was able to bring our vision into reality."
        },
        {
            name:"George Keller",
            cont:" Andrew is amazing, he listened to me .Then took my ideas and thoughts and turned then into a work of art. He is super creative, patient, kind and available through the whole process. I fell blessed to have found him."
        },
    ]
  const gallery =[

        {
           miniTitle:"web design",
           title:"Chosen On Base",
           img:chosenmockup,
           link:"https://chosenonbase.com",
           desc:"Chosen is a bold, community-driven platform I designed to give underdogs a place to shine and connect. The goal was to create an energetic, street-style vibe that celebrates individuality and movement. From the sleek visuals to the interactive features, every element was built to capture that raw, authentic energy and help users feel like they’re part of something bigger. Tech stack: Figma, HTML, CSS, JavaScript.",
        },
        {

           miniTitle:"web design",
           title:"Running George",
           img:runninggeorge,
           link:" https://runninggeorge.com/",
                      desc:"Running George is the deeply personal memoir of George Keller — a journey from hardship to healing. The book, Gimmie Shelter: Running George and the High Price of Philadelphia Freedom, follows George’s transformation from a life of struggle to one of redemption and purpose. Tech stack: Figma, Elementor, WordPress ",
        },
        {
           miniTitle:"web design",
           title:"White Mountain Construction",
           img:whitemountainsimg,
           link:"https://kitsaptractorservice.com/",
           desc:"White Mountain Construction brings serious muscle and skill to every job, from grading and clearing to site prep across Kitsap County. They’re known for tackling messy, heavy-duty projects with precision and leaving behind clean, ready-to-build spaces. Tech stack: Figma, HTML, CSS, JavaScript. ",
        },
        {
           miniTitle:"web design",
           title:"A-Z Landscaping",
           img:a2z,
           link:"https://chosenonbase.com",
           desc:"A local landscaping crew with a solid reputation for honest work and beautiful results. A to Z Landscaping & More offers fully customized lawn care, gravel driveways, retaining walls, and stone pathways,  all built with care and precision. Tech stack: Figma, HTML, CSS, JavaScript ",
        },
    ]
  const timerRef = useRef(null); // store timer so we can control it
  // start the auto slide
  const startAutoSlide = () => {
    timerRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev === gallery.length - 1 ? 0 : prev + 1));
    }, 3000);
  };
  // stop auto slide
  const stopAutoSlide = () => {
    clearInterval(timerRef.current);
  };
  // set up effect
  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide(); // cleanup
  }, [gallery.length]);

  // handle hover events
  const handleMouseEnter = () => stopAutoSlide();
  const handleMouseLeave = () => startAutoSlide();

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

    const toggleFaq = (index) =>{
        console.log("aloo")
        setActiveIndex((prev)=>(prev === index ? null : index))

    }

    const toCall = ()=>{
      window.location.href="tel: 360-440-3140"
    }


  return (
    <div>
      <div className="floatingContact" ref={floatContact}>
        <div className="contactForm contactFormFloat">
                <div className="contactFormPlc">
                  <div className="fonContCancel" onClick={hideFloatContact}>
                    <FontAwesomeIcon icon={faX} className="faIcon"/>
                  </div>
                    <div className="contactSinglesInputs">
                        <div className="inputWrap">
                            <p>Your Name</p>
                            <div className="inputWrapper inputWrapperFloat">
                                <input ref={firstnameUser} type="text" placeholder="Name" />
                            </div>
                            <div className="erroTag">
                                <p>{errors.fname}</p>
                            </div>
                        </div>
                        {/* <div className="inputWrap">
                            <p>Last name</p>
                            <div className="inputWrapper inputWrapperFloat">
                                <input type="text" ref={lastnameUser} placeholder="Last" />
                            </div>
                                   <div className="erroTag">
                                <p>{errors.lname}</p>
                            </div>
                        </div> */}
                    </div>
                    <div className="contactDuosInputs">
                        <div className="inputWrap">
                            <p>Email</p>
                            <div className="inputWrapper inputWrapperFloat">
                                <input type="email" ref={emUser} placeholder="Email" />
                            </div>
                            <div className="erroTag">
                                <p>{errors.email}</p>
                            </div>
                        </div>
                        <div className="inputWrap">
                            <p>Phone Number</p>
                            <div className="inputWrapper inputWrapperFloat">
                                <input type="number" ref={fonUser} placeholder="Enter phone" />
                            </div>
                                   <div className="erroTag">
                                <p>{errors.phone}</p>
                            </div>
                        </div>
                    </div>
                    <div className="contactDuosInputs">
                        <div className="inputWrap">
                            <p>Budget</p>
                            <div className="inputWrapper inputWrapperFloat">
                                <input ref={budgetUser} type="text" placeholder="$" />
                            </div>
                                   <div className="erroTag">
                                <p>{errors.budget}</p>
                            </div>
                        </div>
                        <div className="inputWrap">
                            <p>How did you hear about me?</p>
                            <div className="inputWrapper inputWrapperFloat">
                                <select name="" ref={knowUser} id="">
                                    <option value=""></option>
                                    <option value="Google search">Google search</option>
                                    <option value="Instagram">Instagram</option>
                                    <option value="Facebook">Facebook</option>
                                    <option value="Youtube Ads">Youtube Ads</option>
                                    <option value="Referral">Referral</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                                   <div className="erroTag">
                                <p>{errors.know}</p>
                            </div>
                        </div>
                    </div>
                    <div className="contactSinglesInputs contactSinglesInputsfloat">
                        <p>What do you need help with?</p>
                        <div className="textWrapper">
                                 <textarea name="" ref={descUser} id="" placeholder="Please briefly describe your project."></textarea>
                            </div>
                                   <div className="erroTag">
                                <p>{errors.description}</p>
                            </div>

                    </div>
                    <div className="contantFloatBtn">
                      <button onClick={getQuote}>Send</button>
                    </div>
                </div>
            </div>

      </div>
      <button ref={floatBtnRef} className="floatBtn yllBtn" onClick={toCall}> 
        <FontAwesomeIcon icon={faPhone} className="faIcon" />
        Call Now
      </button>
    <div className="navSlide" ref={navSlide}>
      <div className="navSlidePlacer">
        <p onClick={toPortfolio}>See our work </p>
        <p onClick={toTestimonial}>Testimonials </p>
        <p onClick={toFAQ}>FAQ </p>
        <p onClick={showFloatContact}>Contact </p>
        <div className="navSlideCnl" onClick={cnclNavSlider}>
          <FontAwesomeIcon icon={faX} className="faIcon" />
        </div>
      </div>
    </div>
      <section id="Home">
        <div className="homeLayer">
          <nav>
            <div className="navPlc">
              <div className="navLogo">
                <img src={logo} alt="logo" />
              </div>
              <div className="navRight">
                <div className="navBtn" onClick={toCall}>
                  <div className="navBtnIcon">
                    <FontAwesomeIcon icon={faPhone} className="faIcon" />
                  </div>
                  <div className="navBtnNumber">
                    <p>360-440-3140</p>
                  </div>
                </div>
                <div className="navIcon" onClick={showNavSlider}>
                  <FontAwesomeIcon icon={faBars} className="faIcons" />
                </div>
              </div>
            </div>
          </nav>

          <div className="heroCont">
            <div className="heroTop">
              <div className="heroIntro">
                <p>[ welcome to ]</p>
                <h1>
                  Port Orchard <br /> web design & marketing.
                </h1>
                <p className="heroIntroP">
                  I help local businesses in Port Orchard and Kitsap County stand out
online with beautiful websites and smart marketing that attract real
customers. Let’s grow your business together, right here in our
community. {" "}
                </p>
                <div className="heroBtns">
                  <button className="yllBtn" onClick={showFloatContact}>Get a free quote</button>
                  <button className="trsBtn" onClick={toPortfolio}>See my work</button>
                </div>
              </div>
            </div>
            <div className="heroBtm">
              <span>
                Local businesses <br />
                I've worked with
              </span>
              <div className="heroImgs">
                <img  src={allLogos} alt="" />
              
              </div>
            </div>
          </div>
        </div>
      </section>
<section id="webdesign">
      <div className="webDesignplacer"
          onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="webdesignWrap"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {gallery.map((item, index) => (
            <div className="webdesignCard" key={index}>
              <div className="webdesignleft">
                <p>
                  <span>[</span> {item.miniTitle} <span>]</span>
                </p>
                <h2>{item.title}.</h2>
                <p>{item.desc}</p>

                <a className="designLink" href={item.link}>
                  Visit website{" "}
                  <FontAwesomeIcon
                    icon={faArrowUpRightFromSquare}
                    className="faIcon"
                  />
                </a>
              </div>
              <div className="webdesignright">
                <img src={item.img} alt={item.title} />
              </div>
            </div>
          ))}
        </div>

        {/* Circle navigation */}
        <div className="webdesignNav">
          {gallery.map((_, index) => (
            <div
              key={index}
              className={`miniCircle ${
                currentIndex === index ? "mcactive" : ""
              }`}
              onClick={() => goToSlide(index)}
            ></div>
          ))}
        </div>
      </div>
    </section>
      <section id="marketing">
        <div className="marketingPlc">
          <div className="markentingIntro">
            <p>[ marketing ]</p>
            <h2>Be found, online.</h2>
            <p>
             I help small businesses in Port Orchard and throughout
Kitsap County reach more customers through smart,
local-focused marketing. From Google and social media
ads to local SEO, I make sure your business shows up
where it matters most.
            </p>
          </div>
          <div className="marketWrap">
            <div className="marketWrapImg marketWrapImgSt">
              <img src={gym} alt="" />
            </div>
            <div className="marketWrapImg marketWrapImgCnt">
              <img src={jenn} alt="" />
            </div>
            <div className="marketWrapImg marketWrapImgEnd">
              <img src={sneaky} alt="" />
            </div>
          </div>
          <button className="trsBtn" onClick={showFloatContact}>Get a free quote</button>
        </div>
      </section>
      <section id="testimonial">
        <div className="testimonialPlc">
          <div className="testLeft">
            <p>
              <span>[</span> word on the street <span>]</span>
            </p>
            <h2>What they’re saying.</h2>
            <p>
              Port Orchard web design and marketing is all about
helping local businesses grow, and it shows. Don’t just
take my word for it, though; here, you’ll see real reviews
from local businesses I’ve worked with, sharing their
experiences and the results we’ve achieved together. {" "}
            </p>
            <div className="testimonialImg">
              <img src={star} alt="star" />
              <img src={googleImg} alt="google-rank" />
            </div>
          </div>
          <div className="testRight">
            <div className="testWrapContainer">
 {[...testimonials, ...testimonials].map((testimonial)=>(
                  <div className="testWrap">
                      <h3>{testimonial.name}</h3>
                            <div className="testStart">
                                <FontAwesomeIcon className="faIcon" icon={faStar} />
                                <FontAwesomeIcon className="faIcon" icon={faStar} />
                                <FontAwesomeIcon className="faIcon" icon={faStar} />
                                <FontAwesomeIcon className="faIcon" icon={faStar} />
                                <FontAwesomeIcon className="faIcon" icon={faStar} />
                            </div>
                            <p>{testimonial.cont}</p>
                            </div>

                ))}

            </div>
          </div>
        </div>
      </section>
      <section id="designer">
        <div className="designerPlc">
          <div className="designerLeft">
            <p>[ about me ]</p>
            <h2>Hi, I’m Andrew Wandola.</h2>
            <p>
             I’ve spent the last five years designing and building
websites that help businesses grow online.
            </p>
            <p>
             I live here in Port Orchard, so I get what it takes to
connect with local customers in this beautiful town and throughout Kitsap County. 
            </p>
            <p>If you need a custom website, marketing tips, or anything
along those lines, please reach out today for a free
consultation. I’ll be happy to help.             </p>
          </div>
          <div  data-aos="fade-down" className="designerRight">
            <img src={azee} alt="andrew_image" />
          </div>
        </div>
      </section>
      <section id="whyme">
        <div className="whymePlc">
          <div className="whymeIntro">
            <p>[ why me ]</p>
            <h2>I'm different.</h2>
            <p>
As your Port Orchard web designer, here’s why you
should trust me to work on your project.             </p>
          </div>
           <div className="whyDiv2">
            <div className="whyDivRight">
              <img className="upwork" src={upwork} alt="upwork" />
            </div>
            <div className="whyDivLeft">
              <h2>01. Top-rated on Upwork.</h2>
              <p>
               I’m not just a random web designer; I’m your neighbor.
Being fully based in Port Orchard means I understand the
local market, your customers, and the unique challenges
and opportunities businesses face here, including
Bremerton, Bainbridge Island, Silverdale, Poulsbo,
Parkwood, Manchester, Tracyton, Indianola, Kingston,
Seabeck, Gorst, Keyport, Port Gamble, Navy Yard City,
Enetai, Hansville, Southworth, and the entire Kitsap
County.
              </p>
              <p>
                Every website and marketing strategy I create is designed
to connect with your community. I focus on helping your
business stand out, attract local customers, and grow
right here at home, where it matters most.
              </p>
            </div>
          </div>
          <div className="whyDiv1">
            <div className="whyDivLeft">
              <h2>02. Custom designs only.</h2>
              <p>


Every website I build is 100% custom. No drag-and-drop
templates or cookie-cutter layouts. You need a website
that'll actually stand out and reflect your business. You
don't need something that'll look like everyone else’s. 
              </p>
              <p>
                A custom build also runs faster, performs better on
mobile, and gives you room to grow without the limits of
template-based tools. And as a small business owner, you
understand just how important growth is to your
business.
              </p>
              <p>
                Basically,  when you hire me, you get a site built for you. A
site that showcases your unique identity. Your style. Your
vision. Your personality. A website that's impossible to
ignore and difficult to forget. 
              </p>
            </div>
            <div  className="whyDivRight">
              <img src={uniquedesign} alt="phone" />
            </div>
          </div>
          <div className="whyDivSp">
            <h2>03. Digital marketing pro.</h2>
              <p>
               I’ve been a digital marketer for over 12 years. And I’ve learned so much over the years. From the early 2010s, when
keyword stuffing was enough to get your website on Google, to the new age of AI, I’ve seen it all. 
              </p>
              <p>
               When you hire me, you can be confident that you’re working with a web designer who not only knows how to make
websites look good, but also bring in leads. That two-in-one combo is rare to come by these days. 
              </p>
          </div>
           <div className="whyDiv3">
            <div className="whyDivLeft">
              <h2>04. Mobile first, always.</h2>
              <p>


More than <a href="https://www.statista.com/statistics/277125/share-of-website-traffic-coming-from-mobile-devices/">60% of global website</a>  traffic comes from
mobile devices, which means your customers are likely
visiting your site on their phones. I design every website
with a mobile-first approach, ensuring it looks great,
loads fast, and is easy to navigate on any device.
              </p>
              <p>
               By focusing on mobile from the start, I help Port Orchard
businesses capture more visitors, keep them engaged,
and turn clicks into real customers.
              </p>
            </div>
            <div className="whyDivRight">
              <img className="bigPhone" src={phone1} alt="phone" />
            </div>
          </div>
          <div className="whyDiv2">
            <div className="whyDivRight">
              <img className="azeeImg" src={phone2} alt="phone" />
            </div>
            <div className="whyDivLeft">
              <h2>05. 100% local.</h2>
              <p>
               I’m not just a random web designer; I’m your neighbor.
Being fully based in Port Orchard means I understand the
local market, your customers, and the unique challenges
and opportunities businesses face here, including
Bremerton, Bainbridge Island, Silverdale, Poulsbo,
Parkwood, Manchester, Tracyton, Indianola, Kingston,
Seabeck, Gorst, Keyport, Port Gamble, Navy Yard City,
Enetai, Hansville, Southworth, and the entire Kitsap
County.
              </p>
              <p>
                Every website and marketing strategy I create is designed
to connect with your community. I focus on helping your
business stand out, attract local customers, and grow
right here at home, where it matters most.
              </p>
            </div>
          </div>
          <div className="whyDiv3">
            <div className="whyDivLeft">
              <h2>06. Pro small businesses.</h2>
              <p>
               I get small businesses because I work with them every
day. And, yes, I’m a small business too. Here’s the thing:
you don’t need complicated stuff or a big budget. You just
need something that works and helps you get noticed.
              </p>
              <p>
               I make websites and marketing that actually fit your
business, your goals, and your pace. 
              </p>
              <p>
               No tech headaches. No over-the-top agency nonsense.
No hidden costs. 
              </p>
              <p>Just real solutions that help your business grow.</p>
            </div>
            <div className="whyDivRight fidiLapi">
              <img src={laptop} alt="laptop" />
            </div>
          </div>
        </div>
      </section>
      <section id="faqs">
        <div className="faqsPlc">
            <div className="faqsIntro">
                <p> <span>[ </span>faqs<span> ]</span> </p>
 <h2>Your questions, answered.</h2>
            <p>I know you probably have a few questions about how I work, what I offer, and how my website design service
can help your business grow online. Here are some of the most common questions I get from local business
owners — and my answers — to give you a clearer picture of what working with me looks like.</p>
            </div>
            <div className="accordion">

                {faqs.map((faq,index)=>(

<div
  className={`faq ${activeIndex === index ? "active" : ""}`}
  key={index}
  onClick={() => toggleFaq(index)}
>
  <div className="question">
    <p>
      <FontAwesomeIcon
        icon={activeIndex === index ? faMinus : faAdd}  // 👈 toggle icon
        className="faIcon"
      />
      {faq.question}
    </p>
  </div>

  <div className="answer">
    <p>{faq.answer}</p>
  </div>
</div>

                ))}

             
              
            </div>
            <button className="yllBtn" onClick={toContact}>I need a quote</button>
           
        </div>

      </section>
      {/* <section id="contact">
        <div className="contactPlc">
            <div className="contactIntro">
                <p>[ let's do this]</p>
                <h2>Get a free quote.</h2>
                <p>Ready to get your business online and noticed? Fill out
the form below for a free quote.

</p>
            </div>
            <div className="contactForm">
                <div className="contactFormPlc">
                    <div className="contactDuosInputs">
                        <div className="inputWrap">
                            <p>First name</p>
                            <div className="inputWrapper">
                                <input ref={firstnameUser} type="text" placeholder="First" />
                            </div>
                            <div className="erroTag">
                                <p>{errors.fname}</p>
                            </div>
                        </div>
                        <div className="inputWrap">
                            <p>Last name</p>
                            <div className="inputWrapper">
                                <input type="text" ref={lastnameUser} placeholder="Last" />
                            </div>
                                   <div className="erroTag">
                                <p>{errors.lname}</p>
                            </div>
                        </div>
                    </div>
                    <div className="contactDuosInputs">
                        <div className="inputWrap">
                            <p>Email</p>
                            <div className="inputWrapper">
                                <input type="email" ref={emUser} placeholder="Email" />
                            </div>
                            <div className="erroTag">
                                <p>{errors.email}</p>
                            </div>
                        </div>
                        <div className="inputWrap">
                            <p>Phone Number</p>
                            <div className="inputWrapper">
                                <input type="number" ref={fonUser} placeholder="Enter phone" />
                            </div>
                                   <div className="erroTag">
                                <p>{errors.phone}</p>
                            </div>
                        </div>
                    </div>
                    <div className="contactDuosInputs">
                        <div className="inputWrap">
                            <p>Budget</p>
                            <div className="inputWrapper">
                                <input ref={budgetUser} type="text" placeholder="$" />
                            </div>
                                   <div className="erroTag">
                                <p>{errors.budget}</p>
                            </div>
                        </div>
                        <div className="inputWrap">
                            <p>How did you hear about me?</p>
                            <div className="inputWrapper">
                                <select name="" ref={knowUser} id="">
                                    <option value=""></option>
                                    <option value="Google search">Google search</option>
                                    <option value="Instagram">Instagram</option>
                                    <option value="Facebook">Facebook</option>
                                    <option value="Youtube Ads">Youtube Ads</option>
                                    <option value="Referral">Referral</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                                   <div className="erroTag">
                                <p>{errors.know}</p>
                            </div>
                        </div>
                    </div>
                    <div className="contactSinglesInputs">
                        <p>What do you need help with?</p>
                        <div className="textWrapper">
                                 <textarea name="" ref={descUser} id="" placeholder="Please briefly describe your project."></textarea>
                            </div>
                                   <div className="erroTag">
                                <p>{errors.description}</p>
                            </div>

                    </div>
                </div>
            </div>
            <div className="contactBtn">
                <button className="yllBtn" onClick={showFloatContact}>Send message</button>

            </div>
        </div>


      </section> */}
      <footer>
        <div className="footerPlc">
            <div className="footerLeft">
            <p>Copyright @ 2025, All rights reserved.</p>

            </div>
            <div className="footerRight">
                <p>4975 Hidden Terrance Ln SE #404</p>
                <p>Port Orchard, WA 98366</p>
            </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;
